import { useNavigate } from "react-router-dom";
import { Character, GameInstance, State } from "../../types";
import { useDispatch, useSelector } from "react-redux";
import { Form, Modal } from "react-bootstrap";
import { actions, closeWindow, openWindow } from "../../actions";
import { baseURI, baseURL, socket } from "../../api";
import { useEffect, useState } from "react";
import AppModal from "../Common/AppModal";
import AppButton from "../Common/AppButton";
import Calendar from "../3D/subcomponents/Calendar";
import CharThumb from "../3D/subcomponents/CharThumbnail";

interface Props {
}
const Home: React.FC<Props> = () => {

    const characters = useSelector((store: State) => store.characters)
    const dispatch: any = useDispatch();
    const userStatus = useSelector((store: State) => store.userStatus)

    const [selectedCharacter, setSelectedCharacter] = useState<Character | null>(null);
    const [selectedGameInstance, setSelectedGameInstance] = useState<Character["onGoingGames"][number] | null>(null)

    const [newCharacterName, setNewCharacterName] = useState<string>("");
    const createNewCharacter = () => {
        socket.emit("createCharacter", { name: newCharacterName })
    }
    const deleteCharacter = (c: Character) => {
        if (window.confirm("Really delete character " + c.name + "?")) {
            socket.emit("deleteCharacter", { id: c.id })
            dispatch(closeWindow("character"))
            setSelectedCharacter(null)
        }
    }

    useEffect(() => {
        if (userStatus.installationActive === false) {
            dispatch(openWindow("login"))
        }
    });

    useEffect(() => {
        if (selectedCharacter) {
            const c = characters.find(c => c.id === selectedCharacter.id) ?? null
            setSelectedCharacter(c)
            setSelectedGameInstance(null)
        }
    }, [characters, selectedCharacter]);

    let navigate = useNavigate();

    useEffect(() => {
        socket.on("play", async (d: GameInstance) => {
            console.log("Server says PLAY!");
            // TODO: Dispatch probably isn't asynch (at least not all the way to the state)
            await dispatch(actions.setGameInstanceAction(d))
            dispatch(closeWindow("character"))
            navigate(`${baseURI}/play`)
        });

        socket.on("createCharacterOk", (d) => {
            setNewCharacterName("")
            dispatch(closeWindow("createCharacter"))
        });

        return () => {
            socket.off("play");
            socket.off("createCharacterOk");
        };
    });

    // const sendPlayReq = (c: Character) => {
    //     dispatch(actions.setCurrentCharacterIdAction(c.id))
    //     socket.emit("play", {charId: c.id, gameInstanceId: selectedGameInstance?.id})
    // }

    const playStory = () => {
        const game = selectedCharacter?.onGoingGames.find(g => g.type === "story")
        if (game) {
            dispatch(actions.setCurrentCharacterIdAction(selectedCharacter?.id ?? ""))
            socket.emit("play", {charId: selectedCharacter?.id, gameInstanceId: game.id})
        } else {
            dispatch(openWindow("story"))
        }
    }

    const sendPlayReqArkham = (c: Character) => {
        dispatch(actions.setCurrentCharacterIdAction(c.id))
        const game = selectedCharacter?.onGoingGames.find(g => g.type === "perpetual")
        if (game) {
            socket.emit("play", {charId: c.id, gameInstanceId: game.id})
        } else {
            socket.emit("play", {charId: c.id, mapId: "arkham_v02"})
        }
    }

    const sendPlayReq = (c: Character, mapId: string) => {
        dispatch(actions.setCurrentCharacterIdAction(c.id))
        const game = selectedCharacter?.onGoingGames.find(g => g.type === "story")
        if (game) {
            socket.emit("play", {charId: c.id, gameInstanceId: game.id})
        } else {
            socket.emit("play", {charId: c.id, mapId: mapId})
        }
    }

    const sendExitReq = () => {
        if (!window.confirm("Destroy game instance?")) { return }
        const c = selectedCharacter
        const g = selectedGameInstance
        if (!c || !g) { return }
        socket.emit("exitGame", {charId: c.id, gameInstanceId: g.id})
    }

    const selectCharacter = (c: Character) => {
        setSelectedGameInstance(null)
        setSelectedCharacter(c)
        dispatch(openWindow("character"))
    }

    return (
        <>
            <div className="mainbg" style={{backgroundImage: `url(${baseURL}/img/graphics/main_bg_01.png)`}}>
            </div>
            <div className="position-relative text-center">
                <div style={{maxWidth: "700px", margin: "0 auto"}}>
                    <img style={{maxWidth: "100%", opacity: 1, marginTop: "40px"}} src={`${baseURL}/img/graphics/logo_outer_dark.png`} alt="Outer Dark" />
                </div>

                <div className="text-center pt-4">
                    <h3>Select Character</h3>
                </div>

                <div className="characters" style={{visibility: userStatus.installationActive ? "visible" : "hidden", backgroundImage: "url(img/ui/bg_noise.png)"}}>
                    {
                        characters.map(
                            (c) => {
                                return (
                                    <div className="clickable mb-2" onClick={() => { selectCharacter(c) }} key={c.id}>
                                        <div key={c.id} className="character">
                                             <span className="h5 name">{c.name}</span> <span className="ms-2">Level {c.exp.lvl}</span>
                                             {/* <div className="description">Currently in {c.location ? c.location?.gameInstanceId.substring(0, 10) + "..." : "(default)"}</div> */}
                                         </div>
                                    </div>
                                )
                            }
                        )
                    }
                    <AppButton className="mt-3" variant="secondary" onClick={() => { dispatch(openWindow("createCharacter")) }}>Create new</AppButton>
                </div>
            </div>
            <AppModal
                name="createCharacter"
                title="Create character"
            >
                <Modal.Body className="p-3">
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Name</Form.Label>
                            <Form.Control type="text" className="semi-transparent" value={newCharacterName} onChange={(e) => { setNewCharacterName(e.target.value); }} />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="p-1">
                    <AppButton className="" variant="secondary" onClick={createNewCharacter}>
                        Create
                    </AppButton>
                </Modal.Footer>
            </AppModal>

            {/* Character modal */}
            <AppModal
                name="character"
                title={selectedCharacter?.name ?? ""}
            >
                <Modal.Body className="p-3">
                    {selectedCharacter && <CharThumb character={selectedCharacter} />}
                    <div className="mt-3">
                        {selectedCharacter?.onGoingGames.map(g => (
                            <div key={g.id}
                                className={`game-list-item clickable mb-2 ${selectedGameInstance?.id === g.id && "glow"} position-relative`}
                                onClick={() => {setSelectedGameInstance(g)}}
                            >
                                <span className="h5">{g.name}</span>
                                <div style={{position: "absolute", right: 0, top: "10px"}}><Calendar minutes={g.time} /></div>
                            </div>
                        ))}
                    </div>
                    <AppButton className="" variant="secondary" onClick={() => { selectedCharacter && sendPlayReqArkham(selectedCharacter) }}>
                        Enter Arkham
                    </AppButton>
                    {/* <AppButton className="" variant="secondary" onClick={() => { selectedCharacter && sendPlayReq(selectedCharacter, "world") }}>
                        Play Story
                    </AppButton> */}
                    <AppButton className="" variant="secondary" onClick={playStory}>
                        Play Story
                    </AppButton>
                </Modal.Body>
                <Modal.Footer className="px-2 py-1" style={{justifyContent: "left"}}>
                    <AppButton className="btn btn-theme-white-noborder" variant="secondary" onClick={() => { selectedCharacter && deleteCharacter(selectedCharacter) }}>
                        Delete char
                    </AppButton>
                    {selectedGameInstance && <AppButton className="" variant="secondary" onClick={sendExitReq}>
                        Destroy game
                    </AppButton>}
                    {/* <AppButton className="" variant="secondary" onClick={() => { selectedCharacter && sendPlayReq(selectedCharacter) }}>
                        {selectedGameInstance ? "Play" : "New Game"}
                    </AppButton> */}
                </Modal.Footer>
            </AppModal>

            {/* Story modal */}
            <AppModal
                name="story"
                title="Select Story"
            >
                <Modal.Body className="p-3">

                    <div
                        className={`game-list-item clickable mb-2 position-relative`}
                        onClick={() => {  dispatch(closeWindow("story")); selectedCharacter && sendPlayReq(selectedCharacter, "world") }}
                    >
                        <span className="h4">Test World</span>
                    </div>

                    <div
                        className={`game-list-item clickable mb-2 position-relative`}
                        onClick={() => {  dispatch(closeWindow("story")); selectedCharacter && sendPlayReq(selectedCharacter, "azathoth") }}
                    >
                        <span className="h4">Azathoth</span>
                    </div>

                </Modal.Body>
                <Modal.Footer className="px-2 py-1" style={{justifyContent: "left"}}>
                </Modal.Footer>
            </AppModal>

        </>

    );
}

export default Home;